<template>

<core-panel>

	<template v-slot:head>

		<h1>Activity</h1>

		<p>The new and returning players in {{ data.period }}.</p>

	</template>

	<template v-slot:body>

		<app-user 
            v-for="(item, index) in list" 
            v-bind:key="index" 
            :tag="(item.type === 'new') ? 'New' : 'Returning'" 
            :tag-theme="(item.type === 'new') ? 'green' : 'blue'" 
            :item="item" 
            count-text="play" 
            :dark="true"
			type="player" 
        />

	</template>

</core-panel>

</template>

<script>

import Panel from './../../common/Panel'

export default {

	mixins: [Panel],

	data: function() {

		return {
			detail: 'activity',
            params: ['band'],
			list: []
		}

	},

	methods: {

		response: function(json) {

			this.list = json.activity

		}

	}

}

</script>